var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box_center"},[_c('div',{staticClass:"leftdiv"},[_vm._v("今日: "+_vm._s(_vm.data)+" "+_vm._s(_vm.nowWeek)+" ")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightdiv"},[_c('a',{attrs:{"href":"#"}},[_vm._v("设置首页")]),_c('span',{staticClass:"spilt"},[_vm._v("|")]),_c('a',{attrs:{"href":"#"}},[_vm._v("加入收藏")])])
}]

export { render, staticRenderFns }